// extracted by mini-css-extract-plugin
export var base = "_10-0";
export var updateBanner = "_10-1";